<template>
  <div class="home net-status-home">
    <Layout
      layoutType="HARDLIST"
      isRevenue="true"
      :pageTitle="$t('menu.standardNode')"
    >
      <BasiceLayout title="监控（下行）">
        <span class="margin-left-20">主机名：</span>
        <el-select
          v-model="newServerBcode"
          placeholder=""
          @change="search"
        >
          <el-option
            v-for="item in hostNameOptions"
            v-if="item.serverHostname"
            :key="item.serverBcode"
            :label="item.serverHostname"
            :value="item.serverBcode"
          >
          </el-option>
        </el-select>
        <!-- <el-input
          v-model="searchBcode"
          placeholder="输入要搜索的bcode"
          style="max-width: 200px"
        ></el-input> -->
        <span class="margin-left-20">日期：</span>
        <el-date-picker
          v-model="selectDate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          @change="search"
        >
        </el-date-picker>
        <div v-loading="isLoading" style="width: 100%; min-height: 100px;">
          <div class="standard-node-watch">
            <ve-line
              v-if="flowResult &&  flowResult.rows && flowResult.rows.length"
              class="watch-chart"
              :data="flowResult"
            ></ve-line>
          </div>
        </div>
      </BasiceLayout>
    </Layout>
  </div>
</template>
<i18n>
{
  "en": {
    "flowText": "下行单节点带宽（Mbps）",
    "cpuText": "CPU使用率（百分比）",
    "memText": "内存使用率（百分比）",
    "diskIoText": "节点磁盘IO"
  }
}
</i18n>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import moment from "moment";
import { Message } from "element-ui";
import { LANG } from "../../../config/contant.js";
import Layout from "@/components/DatePanel/Layout.vue";
import { BytesToM, toFixed, BytesToG } from "@/utils/utils";

export default {
  name: "home",
  components: {
    BasiceLayout,
    Layout
  },
  data() {
    return {
      searchBcode: '',
      selectDate: "",
      useBandCharts: {},
      flowResult: [],
      pickerOptions:
      this.limitDate(),
      isLoading: false,
      hostNameOptions: [],
      newServerBcode: '',
    };
  },
  methods: {
    ...mapActions(["getetOutFlowRes","getStandardNodeHostNameAndBcode"]),
    limitDate(){
      var curTime = new Date();
      var curYear = curTime .getFullYear();
      var curMonth = curTime .getMonth();
      var curMonthFirstDay = new Date(curYear,curMonth,1);
      var beforeMonth = curMonth-1;

      if(beforeMonth==-1){
        curYear = curYear-1;
        beforeMonth = 11;
      }

      var beforeStartDate = new Date(curYear,beforeMonth,1);

      return {
        disabledDate(time){
          return time.getTime() < moment(beforeStartDate).valueOf()|| time.getTime() > moment().valueOf();
        }
      }
    },
    dealFlow(data) {
      if (!data.length) {
        return;
      }

      let watchDate = this.$t("watchDetail.watchDate");
      let watchUseBand = this.$t("flowText");
      let watchUseBandOut = '上行单节点带宽（Mbps）';
      let useBandCharts = {
        columns: [],
        rows: []
      };

      useBandCharts.columns = [watchDate, watchUseBandOut, watchUseBand];

      data.map(item => {
        let { time, in_bps, out_bps } = item;
        // let value = isDcache ? diffBps : out_bps;
        let value = in_bps;
        let date_at = moment(new Date(time)).format("YYYY-MM-DD HH:mm:ss");

        let useBandRows = [];
        // 日期处理
        useBandRows[watchDate] = date_at;
        useBandRows[watchUseBand] = toFixed(BytesToM(value));
        useBandRows[watchUseBandOut] = toFixed(BytesToM(out_bps));

        useBandCharts.rows.push(useBandRows);
      });

      this.flowResult = useBandCharts;
    },
    search() {
      let { newServerBcode, selectDate } = this;
      const date_after = selectDate ?  moment(selectDate[1]).endOf("day").valueOf() : moment().endOf("day").valueOf()
      const date_before = selectDate ?  moment(selectDate[0]).startOf("day").valueOf() : moment().startOf("day").valueOf()
      this.getData({ bcode: newServerBcode, date_after, date_before });
    },
    getData(data) {
      this.flowResult = [];
      this.isLoading = true;
      this.getetOutFlowRes(data).then(res => {
        this.isLoading = false;
        const flowResult = res.data;
        if (flowResult && flowResult.length) {
          flowResult.forEach(item=>{
            item.time = item.time * 1000;
          })
        }
        this.dealFlow(flowResult);
      });
    },
  },
  created() {
      this.getStandardNodeHostNameAndBcode().then(res => {
        this.hostNameOptions = res.data;
        let server = res.data.find(item => {
          return item.serverHostname;
        });
      });
    }
};
</script>

<style lang="stylus">
.watch-real-data {
  // width: 80%;
  margin: 20px auto;
}
</style>
